import React from 'react';
import cx from 'classnames';

interface DisplayTypeToggleProps {
  onChange: (type: string) => void;
  displayType: string;
}

export default function DisplayTypeToggle({ onChange, displayType }: DisplayTypeToggleProps) {
  return (
    <div className=" gap-x-2 items-center hidden lg:flex">
      <button
        className={cx(' input h-10 w-10 flex items-center justify-center  rounded-md', displayType === 'list' && 'contrast-50')}
        onClick={() => onChange('list')}
      >
        <i className="ri-list-unordered"></i>
      </button>
      <button
        className={cx('input  h-10 w-10 flex items-center justify-center  rounded-md p-2', displayType === 'grid' && 'contrast-50')}
        onClick={() => onChange('grid')}
      >
        <i className="ri-grid-line"></i>
      </button>
    </div>
  );
}
